function AiDisclosure({ showTitle = true }) {
  return (
    <div>
      {showTitle ? (
        <h5 className="fw-bold">
          Disclosure on the Use of Artificial Intelligence
        </h5>
      ) : null}
      <p>
        Our application leverages Artificial Intelligence (AI) to enhance user
        experience by providing advanced features and functionalities. It is
        important to note the following regarding our use of AI:
      </p>
      <ol>
        <li>
          <strong>No Use of Personal Information:</strong>
          <br /> This application does not collect, store, or utilize any
          personal information from its users for AI or any other purposes. All
          AI processes are conducted without access to identifiable or sensitive
          user data.
        </li>
        <li>
          <strong>Purpose of AI Implementation:</strong>
          <br />
          The AI technology in this application is designed to assist with
          generating recommendations and providing insights to educate consumers
          about their vehicle.
        </li>
        <li>
          <strong>Transparency and Security:</strong>
          <br />
          We are committed to transparency in our AI use. All AI operations are
          conducted in accordance with industry best practices, ensuring user
          data security and privacy.
        </li>
        <li>
          <strong>User Control:</strong>
          <br />
          Users retain full control over their interactions with AI features.
          For optional AI-driven functionalities, users can choose whether or
          not to engage with these features.
        </li>
        <li>
          <strong>Non-intrusive Functionality:</strong>
          <br />
          AI operates only within the scope of the application and does not
          interact with external data sources beyond the scope necessary for the
          specified features.
        </li>
      </ol>
      <p>
        By using this application, you acknowledge and accept the implementation
        of AI under the outlined conditions.
      </p>
    </div>
  );
}

export default AiDisclosure;
